import { JohaisetsuTypeMap } from '@/models/apis/johaisetsu/johaisetsuCommon';

// 前回選択した作業種別を初期表示する(選択肢にない値の場合は空にする)
export const resolveInitialWorkType = (
  selectedJohaisetsuType: string,
  johaisetsuTypes: JohaisetsuTypeMap[],
): string => {
  return johaisetsuTypes.some(e => e.key === selectedJohaisetsuType) ? selectedJohaisetsuType : '';
};
